import { render, staticRenderFns } from "./skillTab.vue?vue&type=template&id=41dc3abd&scoped=true&"
import script from "./skillTab.js?vue&type=script&lang=js&"
export * from "./skillTab.js?vue&type=script&lang=js&"
import style0 from "./skillTab.css?vue&type=style&index=0&id=41dc3abd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dc3abd",
  null
  
)

export default component.exports